module.exports = __webpack_public_path__ + "img/thumb-active.ce97b858.png";